<template>
  <div>
    <div style="font-size: 14px; color: #606266;">
      <span>Status：{{ formData.v_userStatus }}</span>
      <el-divider direction="vertical"></el-divider>
      <span
        >Create：{{ formData.createByName }} at {{ formData.createDate }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span
        >Modify：{{ formData.modifyByName }} at {{ formData.modifyDate }}</span
      >
    </div>
    <div class="d2-mt">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="medium"
      >
        <el-row :gutter="20">
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('form_label_user_account') || '用户账号'"
              prop="userNo"
            >
              <el-input
                v-model="formData.userNo"
                :placeholder="
                  $l('form_label_please_user_account') || '请输入用户账号'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('table_label_chinese_name') || '中文姓名'"
              prop="userName"
            >
              <el-input
                v-model="formData.userName"
                :placeholder="
                  $l('form_label_please_chinese_name') || '请输入中文姓名'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item :label="$l('form_label_english_name') || '英文姓名'">
              <el-input
                v-model="formData.userNameEn"
                :placeholder="
                  $l('form_label_please_chinese_name') || '请输入英文姓名'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('from_radio_phone_number') || '手机号码'"
              prop="mobileNumber"
            >
              <el-input
                v-model="formData.mobileNumber"
                maxlength="11"
                :placeholder="
                  $l('from_label_Please_phone_number') || '请输入手机号码'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('from_radio_mailing_address') || '邮件地址'"
              prop="emailAddress"
            >
              <el-input
                v-model="formData.emailAddress"
                :placeholder="
                  $l('from_label_Please_mailing_address') || '请输入邮件地址'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('table_label_abb_english_name') || '英文名称缩写'"
            >
              <el-input
                v-model="formData.userShortNameEn"
                :placeholder="
                  $l('from_label_Please_abb_english_name') ||
                    '请输入英文名称缩写'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('form_label_fixed_telephone') || '固定电话'"
            >
              <el-input
                v-model="formData.fixedTelephone"
                :placeholder="
                  $l('from_label_Please_fixed_telephone') || '请输入固定电话'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('form_label_organization') || '所属机构'"
              prop="orgCode"
            >
              <dict-select
                clearable
                v-model="formData.orgCode"
                :body="orgParams"
                url="/sys/common/dict/orgDict"
                :placeholder="
                  $l('from_label_Please_organization') || '请选择所属机构'
                "
                filterable
                :selectedLabel.sync="formData.orgName"
                @change="orgChange"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('form_label_department') || '所属部门'"
              prop="depCode"
            >
              <dict-select
                clearable
                v-model="formData.depCode"
                :body="depParams"
                url="/sys/common/dict/depDict"
                :placeholder="
                  $l('from_label_Please_department') || '请选择所属部门'
                "
                filterable
                :selectedLabel.sync="formData.depName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
            <el-form-item
              :label="$l('form_label_hold_a_position') || '担任职务'"
            >
              <el-input
                v-model="formData.userPost"
                maxlength="50"
                :placeholder="
                  $l('from_label_Please_hold_a_position') || '请输入担任职务'
                "
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item :label="$l('form_label_business_role') || '业务角色'">
              <dict-select
                clearable
                v-model="formData.userJobType"
                :body="userJobTypeParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('from_label_Please_business_role') || '请选择业务角色'
                "
                filterable
                :selectedLabel.sync="formData.v_userJobType"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 8 }">
            <el-form-item
              :label="
                $l('form_label_cg_cr_permission_range') || '对应客户权限范围'
              "
            >
              <dict-select
                clearable
                v-model="formData.userCustRange"
                :body="userCustRangeParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('from_label_Please_cg_cr_permission_range') ||
                    '请选择对应客户权限范围'
                "
                filterable
                :selectedLabel.sync="formData.v_userCustRange"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="d2-mt">
      <div class="side-frame-success">
        {{ $l('form_label_permission_role') || '权限角色' }}
      </div>
      <div>
        <RoleList :disabled="disabled" :userCode="userCode" ref="roleTable" />
      </div>
    </div>
  </div>
</template>
<script>
import RoleList from './role-list'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: { RoleList },
  props: {
    disabled: Boolean,
    userCode: String,
  },
  data() {
    return {
      orgParams: {},
      depParams: {},
      userJobTypeParams: { dictType: 'userJobType' },
      userCustRangeParams: { dictType: 'userCustRange' },
      backDialogVisible: false,
      formData: {},
      rules: {
        userNo: [
          {
            required: true,
            message:
              this.$l('form_label_please_user_account') || '请输入用户账号',
            trigger: 'blur',
          },
        ],
        userName: [
          {
            required: true,
            message: this.$l('table_label_chinese_name') || '中文姓名',
            trigger: 'blur',
          },
        ],
        mobileNumber: [
          {
            required: true,
            message:
              this.$l('from_label_Please_phone_number') || '请输入手机号码',
            trigger: 'blur',
          },
        ],
        emailAddress: [
          {
            required: true,
            message:
              this.$l('from_label_Please_mailing_address') || '请输入邮件地址',
            trigger: 'blur',
          },
          {
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message:
              this.$l('from_label_Please_correct_email_address') ||
              '请输入正确的邮件地址',
            trigger: 'blur',
          },
        ],
        depCode: [
          {
            required: true,
            message:
              this.$l('from_label_Please_department') || '请选择所属部门',
            trigger: 'change',
          },
        ],
        orgCode: [
          {
            required: true,
            message:
              this.$l('from_label_Please_organization') || '请选择组织机构',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.userCode) return
      this.$api
        .sysUserDetailApi({
          userCode: this.userCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      const roleList = this.$refs.roleTable.getTableData()
      this.loadingOpen()
      this.$api
        .sysUserSaveApi({ ...this.formData, roleList })
        .then(() => {
          this.loadingClose()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    orgChange(val) {
      this.formData.depCode = ''
      this.formData.depName = ''
      this.depParams = { orgCode: val }
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('form_label_saved_successfully') || '系统用户数据保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          callback: () => {
            this.$eventBus.$emit('userSaveSuccess')
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
